import Util from './util';
import {ThemeConfig} from './const';
import * as log from 'loglevel';
import ShopifyStore from './shopify-store';


class ProductVariantOptions {
    constructor(config, productForm, options) {

        // Default settings
        let defaults = {
            product: {},
            variant: {},
            editorMode: false
        }

        // Merge options into defaults
        this.settings = Util.extend(defaults, options || {});

        this.config = config;

        this._productForm = productForm;

        this._init();

        // NEW: Dawn 15.0+ variant options are updated by the theme (auto enable observer)
        if(typeof HTMLUpdateUtility == 'function') { // global Class: https://github.com/Shopify/dawn/blob/main/assets/global.js#L28
            ThemeConfig.productVariantObserver = true;
            Util.addStyleElement('variant-selects {display:none!important;}'); // auto hide the variant options (avoid flickering - required because the element is replaced)
        }
        // NEW: Horizon 1.0+
        else if(ShopifyStore.getInstance().isTheme('Horizon')) {
            // NOT needed: ThemeConfig.productVariantObserver = true;
            // variant options are merged (dom diff) but keeps all the listeners
            Util.addStyleElement('variant-picker {display:none!important;}'); // resets hidden styles
        }

        // NEW: HACKY: allow outside custom observer parent selector <script>window.clVariantObserverParent = '.custom-parent-selector';</script>
        if (window.clVariantObserverParent) {
            ThemeConfig.productVariantObserver = true;
            this.observerParent = window.clVariantObserverParent;
        }

        if(ThemeConfig.productVariantObserver && !this.settings.editorMode){ // editor mode never needs the observer

            this.watchVariantElements();

            /* alternative to watching variant elements (works with ?variant history)  BUT this event fires to early and on Dawn both old/new variant picker is still in the DOM
            productForm.addEventListener('option:variant_changed', () => {
                // re resolve theme elements
                this.resolveThemeElements(true);
                //setTimeout(() => , 100);
            }) */
        }
    }

    // build variant options in our internal format based on the variant shopify options
    _init() {

        let variantOptions = [];

        let optionsIds = null;
        // IMPROVEMENT: add the code to generate options ids the app-embed to always generate the IDs (wait to see if more themes uses this structure)
        let optionsIdsEl = document.querySelector('[data-live-variant-options-ids]');
        if(optionsIdsEl){
            // enable via data attribute (currently enabled via manual code snippet)
            if(optionsIdsEl.hasAttribute('data-variant-observer')){
                ThemeConfig.productVariantObserver = true;
                // NEW: selector for parent
                this.observerParent = optionsIdsEl.getAttribute('data-variant-observer');
            }
            optionsIds = JSON.parse(optionsIdsEl.textContent);
        }

        for (let optionIndex = 0; optionIndex < this.settings.product.options.length; optionIndex++) {

            const option = this.settings.product.options[optionIndex];

            let variantOption = {
                name: option.name,
                label: option.name,
                type: 'select',
                id: 'option_' + this.settings.product.id + '_' + option.name.replace(/^[^a-zA-Z]+|[^\w]+/g, ""),
                params: {
                    // IMPORTANT: prefix to avoid name collusion with the variants from the theme
                    name: 'v_' + option.name, // explicit name=""
                },
                visible: true,
                values: [],
                _variantOption: option, // reference to the shopify option
                _themeEl: null, // original element from theme
            }

            // NEW: optionId based value matching (used on some themes)
            if(optionsIds?.hasOwnProperty(option.position)){
                // find by position match
                const optionValueIds = optionsIds[option.position];

                option.valuesIds = [];
                for (let i = 0; i < option.values.length; i++) {
                    const value = option.values[i];
                    // find by name match to always make sure to have the same ordering in .value and .valuesIds
                    for (let j = 0; j < optionValueIds.length; j++) {
                        const optionIdValue = optionValueIds[j];
                        if(optionIdValue.name === value){
                            option.valuesIds.push(String(optionIdValue.id)); // attribute always read as string
                            break;
                        }
                    }
                }
            }

            // INFO: we merge the variantOption from the config if found
            let found = false;
            for (let i = 0; i < this.config.variantOptions.length; i++) {
                let variantOptionConfig = this.config.variantOptions[i];

                if(variantOptionConfig.name === option.name){
                    // merge backend variant option into the generated option
                    Util.merge(variantOption, variantOptionConfig);
                    found = true;
                    break;
                }
            }

            // NEW: multi language variants cannot match option.name > fallback to index
            if(!found){
                // INFO: no match could also happen when config is attached to different products - no way to detect this
                if(this.config.variantOptions.length > optionIndex){
                    Util.merge(variantOption, this.config.variantOptions[optionIndex]);
                }
            }

            // pre select provided variant (after merge to avoid overwrite)
            if(this.settings.variant.id){
                variantOption.value = this.settings.variant['option' + option.position]; // value defined on variant
            } else {
                variantOption.value = option.values[0]; // pre select first variant
            }

            // flag if backend config values are provided -> merge values
            let hasConfigValues = variantOption.values.length > 0;

            // always map option.values (to get the current variant option values)
            let optionValues = [];
            for (let i = 0; i < option.values.length; i++) {
                let value = option.values[i];
                let optionValue = null;

                // use the pre configured value (can have additional settings like color or custom text)
                if(hasConfigValues){
                    for (let j = 0; j < variantOption.values.length; j++) {
                        const optionValueConfig = variantOption.values[j];
                        if(optionValueConfig && optionValueConfig.value === value){
                            optionValue = optionValueConfig;
                            break;
                        }
                    }
                }

                if(!optionValue){
                    // not found (variants changed and the live product options app was not updated)
                    // INFO: multi lang variants also are not found > this is good to get the auto translated values
                    optionValue = {
                        text: value,
                        value: value
                    };

                    // NEW: map img by index if defined (required for multi lang variants with images)
                    if(hasConfigValues && variantOption.values.length > i && variantOption.values[i].img){
                        optionValue.img = variantOption.values[i].img;
                    }
                }

                optionValues.push(optionValue);
            }

            // update new values
            variantOption.values = optionValues;
            // add to variant options
            variantOptions.push(variantOption);
        }

        // overwrite the config with the updated variant options
        this.config.variantOptions = variantOptions;

        // editorMode (update finds our own options)
        if(!this.settings.editorMode){
            this.resolveThemeElements();
        }
    }

    resolveThemeElements(update = false){

        for (let i = 0; i < this.config.variantOptions.length; i++) {
            const variantOption = this.config.variantOptions[i];

            // shopify variant option reference
            const option = variantOption._variantOption;

            // manual location: data-live-variant-option="{{ forloop.index }}"
            variantOption._themeEl = this._productForm.querySelectorAll('[data-live-variant-option="'+option.position+'"]');
            if(variantOption._themeEl.length === 0){
                // not found
                variantOption._themeEl = null;
            }
            // select only the first element (if multiple are found)
            else if(variantOption._themeEl.length === 1 && variantOption._themeEl[0].tagName === 'SELECT'){
                variantOption._themeEl = variantOption._themeEl[0];
            }

            if(!variantOption._themeEl){
                // first check select elements
                let selectElList = this._productForm.querySelectorAll('select');

                // NEW: update flag to exclude our own rendered variant options
                if(update){
                    selectElList = Array.from(selectElList).filter(el => el.closest('.cl-po--option') === null);
                }

                const valueMatch = (optionValues) => {
                    if(optionValues.length === option.values.length){
                        for (let j = 0; j < optionValues.length; j++) {
                            const optionValue = optionValues[j];
                            if(option.values.indexOf(optionValue) === -1){
                                // NEW: check id match
                                if(option.valuesIds && option.valuesIds.indexOf(optionValue) !== -1){
                                    this._idMatch = true; // flag to use id match on sync
                                    continue;
                                }
                                return false;
                            }
                        }
                        return true;
                    }
                    return false;
                }

                for (let i = 0; i < selectElList.length; i++) {
                    const selectEl = selectElList[i];

                    // NEW: most themes (dawn based) have: name="options[{{ option.name }}]"
                    if(option.name && selectEl.getAttribute('name')?.includes(option.name)){
                        variantOption._themeEl = selectEl;
                        break;
                    }
                    // most themes use: data-index="option{{ forloop.index }}"  one based index
                    else if(selectEl.dataset.index && selectEl.dataset.index.indexOf(option.position.toString()) !== -1){
                        variantOption._themeEl = selectEl;
                        break;
                    } else {
                        // fallback compare actual values
                        let optionValues = [];
                        let optionElList = selectEl.querySelectorAll('option');
                        for (let j = 0; j < optionElList.length; j++) {
                            const optionEl = optionElList[j];
                            optionValues.push(this._decodeValue(optionEl.value));
                        }
                        // check every value
                        if(valueMatch(optionValues)){
                            variantOption._themeEl = selectEl;
                            // break;  NEW: break removed to loop over all selects (name match is preferred)
                        }
                    }
                }

                // check radio elements
                if(!variantOption._themeEl){
                    let radioElList = this._productForm.querySelectorAll('input[type=radio]');

                    // NEW: update flag to exclude our own rendered variant options
                    if(update){
                        radioElList = Array.from(radioElList).filter(el => el.closest('.cl-po--option') === null);
                    }

                    let checked = [];
                    for (let i = 0; i < radioElList.length; i++) {
                        const radioEl = radioElList[i];
                        if(checked.indexOf(radioEl.name) === -1){

                            // only check each group once
                            checked.push(radioEl.name);

                            let radioGroupElList;

                            // NEW: dawn theme have newline in the name (breaks query selector)
                            const radioName = radioEl.name.trim();
                            // check if trim is different (indicates new lines)
                            if(radioName !== radioEl.name){
                                // search with contains to find in names with newlines
                                radioGroupElList = this._productForm.querySelectorAll('input[name*="'+radioName+'"]');
                            } else {
                                radioGroupElList = this._productForm.querySelectorAll('input[name="'+radioName+'"]');
                            }

                            // NEW: most themes (dawn based) have: name="{{ option.name }}"
                            if(option.name && radioEl.getAttribute('name')?.includes(option.name)){
                                variantOption._themeEl = radioGroupElList;
                                break;
                            }
                            // most themes use: data-index="option{{ forloop.index }}"  one based index
                            else if(radioEl.dataset.index && radioEl.dataset.index.indexOf(option.position.toString()) !== -1){
                                variantOption._themeEl = radioGroupElList;
                                break;
                            }
                            // fallback compare actual values
                            else {
                                let optionValues = [];

                                for (let j = 0; j < radioGroupElList.length; j++) {
                                    const radioGroupEl = radioGroupElList[j];
                                    optionValues.push(this._decodeValue(radioGroupEl.value));
                                }
                                // check every value
                                if(valueMatch(optionValues)){
                                    variantOption._themeEl = radioGroupElList;
                                    break;
                                }

                            }

                        }
                    }
                }
            }

            // auto hide the element inclusive the parent label
            if(variantOption._themeEl && ThemeConfig.productVariantHide){

                let themeEl = variantOption._themeEl;
                // radio group select first
                if(Util.isNodeList(variantOption._themeEl)){
                    themeEl = themeEl[0];
                }

                let parent = themeEl; // default hide only itself
                // avoid hiding the product form

                while(parent.parentNode !== this._productForm){
                    // check if the option name is found (indicates that the label is in this element)
                    if(parent.textContent.indexOf(option.name) !== -1){
                        break;
                    }
                    parent = parent.parentNode;
                }
                parent.style.display = 'none';
            }

            log.debug('resolved theme variantOption', variantOption);
        }

        // manual selector: wrapper around all variant options (only used to hide)
        let variantOptionsEl = this._productForm.querySelector('[data-live-variant-options]');
        if(variantOptionsEl != null){
            variantOptionsEl.style.display = 'none';
        }
    }

    watchVariantElements(){

        const mapThemeElements = () => {
            return this.config.variantOptions
                .filter(option => option._themeEl)
                .map(option => {
                    if(Util.isNodeList(option._themeEl)){
                        return option._themeEl[0];
                    }
                    return option._themeEl;
                });
        }

        let parentNode = null;

        let themeElements = mapThemeElements();

        // find common parent node of themeElements
        if(themeElements.length){

            // NEW: custom parent selector
            if(this.observerParent){
                parentNode = themeElements[0].closest(this.observerParent);
            } else {
                // NEW: themes hardcoded selectors              Dawn 15.0    ,  Zest 8.4.0
                parentNode = themeElements[0].closest('variant-selects, variant-picker');

                // NEW: 2nd level parent (for some themes that already match the top selector but need higher up element to work)
                parentNode = parentNode?.closest('[data-block-type="variant-picker"]') || parentNode;

                // all other themes > resolve by finding common parent
                if(!parentNode){
                    parentNode = themeElements[0].parentNode;

                    while(parentNode !== document.body){
                        // check if parentNode contains all themeElements
                        let allFound = true;
                        for (let i = 0; i < themeElements.length; i++) {
                            if(!parentNode.contains(themeElements[i])){
                                allFound = false;
                                break;
                            }
                        }
                        if(allFound){
                            break;
                        }
                        parentNode = parentNode.parentNode;
                    }
                }

                // INFO: (parentNode.parentNode) to observe the parent of the parent to catch all changes AND keep the observer active (no need to reattach)
                parentNode = parentNode?.parentNode;
            }

        }

        if(parentNode){

            this.observer = new MutationObserver((mutationsList) => {

                for(const mutation of mutationsList) {

                    // only if nodes were removed
                    if (mutation.type === 'childList' && mutation.removedNodes.length) {

                        for (let i = 0; i < mutation.removedNodes.length; i++) {

                            // exclude non element type changes (for speed improvement)                          // ignore style changes from lit-html
                            if (mutation.removedNodes.length === 1 && (mutation.removedNodes[0].nodeType !== 1 || mutation.removedNodes[0].tagName === 'STYLE')) {
                                continue;
                            }

                            // nodelist to array to execute checks
                            const nodes = Array.from(mutation.removedNodes);

                            // find if any of the theme elements were removed
                            for (let j = 0; j < themeElements.length; j++) {
                                const themeElement = themeElements[j];

                                // one of the variant options was removed
                                if (nodes.indexOf(themeElement) > -1 || nodes.some(parent => parent.contains(themeElement))) {

                                    log.trace('variant option removed', themeElement);

                                    // re resolve theme elements
                                    this.resolveThemeElements(true);

                                    // get new theme elements to check in observer
                                    themeElements = mapThemeElements();

                                    // stop processing
                                    return;
                                }
                            }
                        }
                    }
                }
            });

            log.debug('watching variant elements', parentNode);

            this.observer.observe(parentNode, {
                // docs: https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver/observe
                subtree: true,
                childList: true
            });
        }
    }

    syncVariantChanges(option) {
        // custom variant options sync to theme option element & trigger change event on the actual option element (required for all themes to run their option logic)
        if(option._themeEl){

            const valueIdLookup = (value) => {
                if(option._variantOption.valuesIds){
                    let index = option._variantOption.values.indexOf(value);
                    if(index !== -1){
                        return option._variantOption.valuesIds[index];
                    }
                }
                return value;
            }

            const isMatch = (inputEl, value) => {
                // leave == instead of ====   ||  NEW: decode value compare support                              ||  NEW: optionValue.id match support
                return inputEl.value == value || this._decode && this._decodeValue(inputEl.value) == value || this._idMatch && inputEl.value == valueIdLookup(value);
            }

            // input group (radio)
            if(Util.isNodeList(option._themeEl)){
                for (let i = 0; i < option._themeEl.length; i++) {
                    const inputEl = option._themeEl[i];
                    if(isMatch(inputEl, option.value)){
                        inputEl.checked = true;
                        inputEl.dispatchEvent(new Event('change', { bubbles: true })); // bubbles: true to send change event upwards (better to support all themes)
                        break;
                    }
                }
            } else if(option._themeEl.tagName === 'SELECT') {
                for (let i = 0; i < option._themeEl.options.length; i++) {
                    const selectOptionEl = option._themeEl.options[i];
                    if(isMatch(selectOptionEl, option.value)){
                        option._themeEl.selectedIndex = i;
                        break;
                    }
                }
                option._themeEl.dispatchEvent(new Event('change', { bubbles: true })); // bubbles: true to send change event upwards (better to support all themes)
            }
        }
    }

    syncAllVariantOptions(){
        for (let j = 0; j < this.config.variantOptions.length; j++) {
            const variantOption = this.config.variantOptions[j];
            this.syncVariantChanges(variantOption);
        }
    }

    // get variant based on the selected options
    findSelectedVariant(){

        // reset current variant
        this.settings.variant = null;

        for (let i = 0; i < this.settings.product.variants.length; i++) {
            const variant = this.settings.product.variants[i];

            let match = true;

            for (let j = 0; j < this.config.variantOptions.length; j++) {
                const variantOption = this.config.variantOptions[j];

                // compare value match
                if(variant['option' + variantOption._variantOption.position] != variantOption.value){
                    match = false;
                    break;
                }
            }

            // found
            if(match){
                // all values matched
                this.settings.variant = variant; // save on settings
                break;
            }
        }

        return this.settings.variant;
    }

    resetVariant(optionChanged){

        // INFO: find the best matching variant based on this.config.variantOptions[].value
        let bestMatch = null;
        let bestMatchCount = -1;

        for (let i = 0; i < this.settings.product.variants.length; i++) {
            const variant = this.settings.product.variants[i];

            // avoid selecting a variant that is not available (if none are available the first variant is selected)
            if(!variant.available){
                continue;
            }

            let match = true;
            let matchCount = 0;

            for (let j = 0; j < this.config.variantOptions.length; j++) {
                const variantOption = this.config.variantOptions[j];

                // compare value match
                if(variant['option' + variantOption._variantOption.position] != variantOption.value){
                    match = false;
                    // INFO: only break if no previous match (for multiple option combinations we look for the best match that required the least changes to the current selection)
                    if(matchCount === 0){
                        break;
                    }
                } else {
                    matchCount++;

                    // hacky way to prefer selecting another variant that has the same selection on the option that was just changed
                    if(optionChanged && optionChanged.value == variantOption.value){
                        matchCount++;
                    }

                    // check if more values match
                    if(matchCount > bestMatchCount){
                        bestMatch = variant;
                        bestMatchCount = matchCount;
                    }
                }
            }
        }

        // select bestMatch or fallback to first variant
        this.settings.variant = bestMatch || this.settings.product.variants[0];

        // INFO: resetting the variantOptions.values requires the template to sync values back to HTML
        for (let i = 0; i < this.config.variantOptions.length; i++) {
            const variantOption = this.config.variantOptions[i];
            let optionPosition = 'option' + variantOption._variantOption.position;

            variantOption.value = this.settings.variant[optionPosition];
        }
    }

    filterVariantValues(){

        let selected = {};

        for (let i = 0; i < this.config.variantOptions.length; i++) {
            const variantOption = this.config.variantOptions[i];

            let optionPosition = 'option' + variantOption._variantOption.position;

            // always filter all values
            let optionValues = variantOption._values || variantOption.values;
            let filteredValues = [];
            for (let j = 0; j < optionValues.length; j++) {
                const optionValue = optionValues[j];

                let available = false;
                // find all variants that match the selections and filter option value
                for (let k = 0; k < this.settings.product.variants.length; k++) {
                    const variant = this.settings.product.variants[k];

                    let match = true;
                    for (const option in selected) {
                        if(selected.hasOwnProperty(option)){
                            if(selected[option] !== variant[option]){
                                match = false;
                                break;
                            }
                        }
                    }

                    // variant matches > check the actual option value
                    if(match){
                        if(variant[optionPosition] === optionValue.value ){
                            available = true;
                            // NEW: map available flag (adds disabled class if not available but does not disable the selection)
                            optionValue.available = variant.available;
                            // IMPORTANT: only break if available - if not we can search further if another variant with this option might be available
                            if(variant.available){
                                break;
                            }
                        }
                    }
                }

                if(available){
                    filteredValues.push(optionValue);
                }
            }

            variantOption._values = optionValues; // all values for next filter
            variantOption.values = filteredValues; // update to only show the filtered values

            // store the current variant selection
            selected[optionPosition] = variantOption.value;
        }

    }

    // some themes have custom value encoding - e.g Ella theme
    _decodeValue(value){
        let encoded = value.split('Special_Double_Quote').join('"').split('Special_Slash').join('/');
        if(encoded !== value){
            this._decode = true; // flag to decode on variant sync
            return encoded;
        }
        return value;
    }
}

export default ProductVariantOptions;